import request from '@/request'
import { COMPANY } from '@/data/api'

export default {
  namespaced: true,
  state: {
    profile: {}
  },
  getters: {
    profile: state => state.profile
  },
  mutations: {
    setProfile (state, profile) {
      state.profile = profile
    }
  },
  actions: {
    async show ({ commit, getters }) {
      try {
        const { data } = await request.get(`${COMPANY.RESOURCE}`)
        commit('setProfile', data)
        return data
      } catch (e) {
        commit('setProfile', {})
      }
    },
    async update (context, params) {
      try {
        await request.post(`${COMPANY.RESOURCE}`, params)
      } catch (e) {
        throw e
      }
    }
  }
}
